module.exports = __webpack_public_path__ + "img/search.d421370a.svg";